/*
 * Shared card renderer for the Dima Maghrib theme.
 * Used by the Card page section (main-card) and the Card selector section.
 * Depends on window.CARD_AUDIO (assets/card-audio.js).
 */
window.DimaMaghrib = window.DimaMaghrib || {};

(function (NS) {
  function audioSrc(base, path) {
    base = base || '';
    if (base && base.charAt(base.length - 1) !== '/') base += '/';
    return base + path.split('/').map(encodeURIComponent).join('/');
  }

  function clear(el) {
    while (el && el.firstChild) el.removeChild(el.firstChild);
  }

  // Render one card's content into the given elements.
  // opts: { id, baseUrl, titleEl, audiosEl, statusEl, fallbackTitle }
  // Returns the heading text that was shown (so the caller can set document.title if it wants).
  function renderCard(opts) {
    var data = window.CARD_AUDIO || {};
    var titleEl = opts.titleEl;
    var audiosEl = opts.audiosEl;
    var statusEl = opts.statusEl;

    clear(audiosEl);
    if (statusEl) statusEl.textContent = '';

    var id = opts.id;
    if (id === null || id === undefined || id === '') {
      titleEl.textContent = opts.fallbackTitle || 'Carte';
      return titleEl.textContent;
    }

    // A card is "known" only if it exists in the data — mirrors the original site.
    if (!Object.prototype.hasOwnProperty.call(data, id)) {
      titleEl.textContent = 'Carte introuvable';
      return titleEl.textContent;
    }

    var card = data[id];
    var heading = 'Carte n°' + card.number;
    titleEl.textContent = heading;

    var clips = card.clips || [];
    if (clips.length === 0) {
      if (statusEl) statusEl.textContent = 'Aucun audio disponible';
      return heading;
    }

    clips.forEach(function (clip) {
      var wrap = document.createElement('div');
      wrap.style.display = 'flex';
      wrap.style.flexDirection = 'column';
      wrap.style.gap = '0.25rem';

      var label = document.createElement('span');
      label.textContent = clip.label || clip.path;

      var audio = document.createElement('audio');
      audio.controls = true;
      audio.preload = 'metadata';
      audio.src = audioSrc(opts.baseUrl, clip.path);
      audio.style.width = '100%';

      wrap.appendChild(label);
      wrap.appendChild(audio);
      audiosEl.appendChild(wrap);
    });

    return heading;
  }

  // [{ id, number }] for every card in the data, sorted by printed card number.
  function cardList() {
    var data = window.CARD_AUDIO || {};
    return Object.keys(data)
      .map(function (id) { return { id: id, number: data[id].number }; })
      .sort(function (a, b) { return parseInt(a.number, 10) - parseInt(b.number, 10); });
  }

  NS.renderCard = renderCard;
  NS.cardList = cardList;
})(window.DimaMaghrib);
